import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { setDrawerState } from '@/redux/actions/uiActions/drawerActions';
import Drawer from '@/components/Drawer';
import RowV2 from '@/components/v2/RowV2';
import ScreenBreadcrumbV2 from '@/components/v2/ScreenBreadcrumbV2';
import { FiX } from '@/components/react-icons/main';
import ScrollContainerV2 from '@/components/v2/ScrollContainerV2';
import SnapshotListRow from './snapshotsDrawer/SnapshotListRow';
import Button from '../Button.jsx';

const SnapshotsDrawer = ({ drawerKey = 'snapshots', title = 'Snapshots', snapshots = [], isDraft = false, onSnapshotAction, customActions = {}, className = 'snapshots-drawer' }) => {
  const drawerState = useSelector((state) => state?.ui?.drawers?.[drawerKey]);
  const show = drawerState?.open;
  const stack = [{ label: title }];

  const handleClose = useCallback(() => {
    setDrawerState(drawerKey, { open: false });
  }, [drawerKey]);

  return (
    <Drawer className={className} onHide={handleClose} show={show}>
      <RowV2 variant={'header'}>
        <RowV2.Left>
          <ScreenBreadcrumbV2 stack={stack} />
        </RowV2.Left>
        <RowV2.Right>
          <Button size={'sm'} icon={FiX} className={'ghost'} onClick={handleClose} />
        </RowV2.Right>
      </RowV2>
      <ScrollContainerV2 className="snapshot-list">
        {snapshots?.map((snapshot, i) => (
          <SnapshotListRow key={snapshot?.id || i} handleClose={handleClose} snapshot={snapshot} workflowIsDraft={isDraft} onSnapshotAction={onSnapshotAction} customActions={customActions} />
        ))}
      </ScrollContainerV2>
    </Drawer>
  );
};

export default SnapshotsDrawer;
